 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXT9780253044174_COVER from '@/components/text/9780253044174_Cover'
 import TEXT9780253044174_HALFTITLE from '@/components/text/9780253044174_Halftitle'
 import TEXT9780253044174_FRONTMATTER from '@/components/text/9780253044174_Frontmatter'
 import LOVE_1 from '@/components/love_1'
 import TEXT9780253044174_TITLEPAGE from '@/components/text/9780253044174_Titlepage'
 import TEXT9780253044174_COPYRIGHT from '@/components/text/9780253044174_Copyright'
 import TEXT9780253044174_CONTENTS from '@/components/text/9780253044174_Contents'
 import TEXT9780253044174_MAPS from '@/components/text/9780253044174_Maps'
 import TEXT9780253044174_PREFACE from '@/components/text/9780253044174_Preface'
 import TEXT9780253044174_ACKNOWLEDGMENTS from '@/components/text/9780253044174_Acknowledgments'
 import TEXT9780253044174_GLOSSARY from '@/components/text/9780253044174_Glossary'
 import TEXT9780253044174_ABBREVIATIONS from '@/components/text/9780253044174_Abbreviations'
 import TEXT9780253044174_HALFTITLE1_ from '@/components/text/9780253044174_Halftitle1_'
 import TEXT9780253044174_INTRODUCTION from '@/components/text/9780253044174_Introduction'
 import TEXT9780253044174_CHAPTER_01 from '@/components/text/9780253044174_Chapter_01'
 import TEXT9780253044174_CHAPTER_02 from '@/components/text/9780253044174_Chapter_02'
 import TEXT9780253044174_CHAPTER_03 from '@/components/text/9780253044174_Chapter_03'
 import TEXT9780253044174_CHAPTER_04 from '@/components/text/9780253044174_Chapter_04'
 import TEXT9780253044174_CHAPTER_05 from '@/components/text/9780253044174_Chapter_05'
 import TEXT9780253044174_CHAPTER_06 from '@/components/text/9780253044174_Chapter_06'
 import LOVE_2 from '@/components/love_2'
 import TEXT9780253044174_CONCLUSION from '@/components/text/9780253044174_Conclusion'
 import TEXT9780253044174_BIBLIOGRAPHY from '@/components/text/9780253044174_Bibliography'
 import TEXT9780253044174_INDEX from '@/components/text/9780253044174_Index'
 import TEXT9780253044174_BACKMATTER from '@/components/text/9780253044174_Backmatter'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/text/9780253044174_Contents",
 			"name" : "text/9780253044174_Contents",
 			"component" : TEXT9780253044174_CONTENTS
 		},
 		{
 			"path" : "/text/9780253044174_Maps",
 			"name" : "text/9780253044174_Maps",
 			"component" : TEXT9780253044174_MAPS
 		},
 		{
 			"path" : "/text/9780253044174_Preface",
 			"name" : "text/9780253044174_Preface",
 			"component" : TEXT9780253044174_PREFACE
 		},
 		{
 			"path" : "/text/9780253044174_Acknowledgments",
 			"name" : "text/9780253044174_Acknowledgments",
 			"component" : TEXT9780253044174_ACKNOWLEDGMENTS
 		},
 		{
 			"path" : "/text/9780253044174_Glossary",
 			"name" : "text/9780253044174_Glossary",
 			"component" : TEXT9780253044174_GLOSSARY
 		},
 		{
 			"path" : "/text/9780253044174_Abbreviations",
 			"name" : "text/9780253044174_Abbreviations",
 			"component" : TEXT9780253044174_ABBREVIATIONS
 		},
 		{
 			"path" : "/text/9780253044174_Halftitle1_",
 			"name" : "text/9780253044174_Halftitle1_",
 			"component" : TEXT9780253044174_HALFTITLE1_
 		},
 		{
 			"path" : "/text/9780253044174_Introduction",
 			"name" : "text/9780253044174_Introduction",
 			"component" : TEXT9780253044174_INTRODUCTION
 		},
 		{
 			"path" : "/text/9780253044174_Chapter_01",
 			"name" : "text/9780253044174_Chapter_01",
 			"component" : TEXT9780253044174_CHAPTER_01
 		},
 		{
 			"path" : "/text/9780253044174_Chapter_02",
 			"name" : "text/9780253044174_Chapter_02",
 			"component" : TEXT9780253044174_CHAPTER_02
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js